export interface BlogPost {
  id: string;
  titleKey: string;
  excerptKey: string;
  contentKey: string;
  image: string;
  date: string;
  readTime: number;
  keywords: string[];
}

export const BLOG_POSTS: BlogPost[] = [
  {
    id: 'wie-finde-ich-die-passende-band',
    titleKey: 'blog.posts.findBand.title',
    excerptKey: 'blog.posts.findBand.excerpt',
    contentKey: 'blog.posts.findBand.content',
    image: 'https://images.pexels.com/photos/1105666/pexels-photo-1105666.jpeg?auto=compress&cs=tinysrgb&w=1200',
    date: '2025-01-15',
    readTime: 6,
    keywords: ['Band finden', 'Musiker', 'Band suchen', 'Bandmitglied werden', 'Musiker finden', 'Schweiz']
  },
  {
    id: 'band-durchstarten-tipps',
    titleKey: 'blog.posts.startBand.title',
    excerptKey: 'blog.posts.startBand.excerpt',
    contentKey: 'blog.posts.startBand.content',
    image: 'https://images.pexels.com/photos/167636/pexels-photo-167636.jpeg?auto=compress&cs=tinysrgb&w=1200',
    date: '2025-01-10',
    readTime: 7,
    keywords: ['Band Promotion', 'Sichtbarkeit', 'Band Marketing', 'Schweizer Musikszene', 'Band Erfolg']
  },
  {
    id: 'musiker-vernetzen-tipps',
    titleKey: 'blog.posts.networking.title',
    excerptKey: 'blog.posts.networking.excerpt',
    contentKey: 'blog.posts.networking.content',
    image: 'https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg?auto=compress&cs=tinysrgb&w=1200',
    date: '2025-01-05',
    readTime: 6,
    keywords: ['Musikernetzwerk', 'Kollaboration', 'Musiker vernetzen', 'Networking', 'Musik Community']
  }
];
